import React from "react";
import { FaEllipsisH } from "react-icons/fa";
import Datatable from "../../../components/datatable/companies/datatable-companies";
import DataStatsSection from "../../../components/datatable/data-stats-section";
import FilterSection from "../../../components/datatable/filter/FilterSection";
import HideFieldSection from "../../../components/datatable/hide/hide-section";
import Pagination from "../../../components/datatable/pagination/pagination";
import ResetTableButton from "../../../components/datatable/reset-table-button";
import SortFieldSection from "../../../components/datatable/sort/sort-section";
import ExpandCardModal from "../../../components/modals/expand-card-modal";
import MessageContainerModal from "../../../components/modals/message-container-modal";
import MoreInfoModal from "../../../components/modals/more-info-modal";
import SearchSection from "../../../components/search/search-section";
import NavBar from "../../navbar/navbar";

/**
 * CompaniesDatatablePage Component
 * 
 * Full-page layout for viewing and managing companies database. Provides comprehensive data exploration
 * interface with statistics overview, advanced search and filtering by industry/stage/location, column
 * visibility control, sorting capabilities, pagination, and expandable company detail cards. Displays
 * company records in tabular format with modal dialogs for detailed information and expanded views.
 * 
 * @param {Object} props - Component props containing companies table state and handlers
 * @returns {JSX.Element} Complete datatable page with navbar, stats, controls, table, and modals
 */
const DatatablePage = ({ props }) => {
  return (
    <div className="datatable-page-layout">
      <NavBar />

      <MessageContainerModal props={props} />

      <div id="shutdowndata">
        <DataStatsSection props={props} />

        <div className="shutdowndatasearchdiv">
          <div className="shutdowndatahidefieldbuttons">
            {/* filter button */}
            <div className="dropdown shutdownfilterdiv">
              <FilterSection props={props} />
            </div>

            {/* hide field button */}
            <HideFieldSection props={props} />

            {/* sort field button */}
            <SortFieldSection props={props} />

            {/* Clear all filters and search */}
            <ResetTableButton props={props} />

            {/* <div className="shutdownellipsisicon">
              <FaEllipsisH />
            </div> */}
          </div>

          <SearchSection props={props} />
        </div>

        <Datatable props={props} />

        <Pagination props={props} />
      </div>

      {/* pop up modal for more row's info */}
      <MoreInfoModal props={props} />

      {/* expand card modal */}
      <ExpandCardModal props={props} />
    </div>
  );
};

export default DatatablePage;
